<template>
  <aside class="site-sidebar" :class="'site-sidebar--' + sidebarLayoutSkin">
    <div class="site-sidebar__inner">
<div class="headleft"> <i><img src="../assets/images/logo.png" class="indexlog"/></i></div>
     <div class="username">{{userName}}</div>
     
        <el-menu
            @select="selectMenu"
            :default-active="menuActiveName"
            class="el-menu-vertical-demo site-sidebar__menu"
            @open="handleOpen"
            @close="handleClose"
            :router="startRouter"
             :collapse="sidebarFold"
        :collapseTransition="false" text-color="#a7b1c2"
            active-text-color="#fff"
        >
           <el-menu-item index="/home" @click="$router.push({ name: 'home' })">
         <i class="el-icon navicon el-icon-s-home"></i><span slot="title" class="navtitle">首页</span> 
        </el-menu-item>
            <div v-for="item in menuList" :key="item.url">
                <!-- 没有子菜单 -->
                    <el-menu-item v-if="item.list==null" :index="item.url">
                         <i :class="'el-icon navicon '+item.icon"></i>
                        <span slot="title" class="navtitle">{{item.name}}</span>
                    </el-menu-item>
              

                <!-- 有子菜单 -->
                <el-submenu v-else :index="item.url">
                    <template slot="title">
                        <!-- <i class="el-icon-menu"></i> -->
                        <i :class="'el-icon navicon '+item.icon"></i>
                        <span slot="title" class="navtitle">{{item.name}}</span>
                    </template>

                    <template v-for="child in item.list">
                        <!-- 这里是类似递归循环 -->
                        <sidebar-item
                            v-if="child.list !=null&&child.list.length>0"
                            :item="child"
                            :key="child.url"
                        />
                        <el-menu-item v-else :key="child.url" :index="child.url">
                            <!-- <i class="el-icon-location"></i> -->
                              <i :class="'el-icon navicon '+child.icon"></i>
                           <span slot="title" class="navtitle"> {{child.name}}</span>
                        </el-menu-item>
                    </template>
                </el-submenu>
            </div>
        </el-menu>
    </div>
      </aside>
</template>
<script>

export default {
    data() {
        return {

            startRouter: true,//开启路由标识， ，启用该模式会在激活导航时以 index 作为 path 进行路由跳转
            currentIndexLight:'',//当前激活菜单的 index  高亮显示
            arrIndex: [],
            dynamicMenuRoutes: [],

        }
    },
  created() {
    this.currentIndexLight=this.$route.path;
    this.menuList = JSON.parse(sessionStorage.getItem("menuList") || "[]");
    this.dynamicMenuRoutes = JSON.parse(
      sessionStorage.getItem("dynamicMenuRoutes") || "[]"
    );
    this.routeHandle(this.$route);
  },
  watch: {
    $route: "routeHandle",
  },
   computed: {
    sidebarLayoutSkin: {
      get() {
        return this.$store.state.common.sidebarLayoutSkin;
      },
    },
    sidebarFold: {
      get() {
        return this.$store.state.common.sidebarFold;
      },
    },
    menuList: {
      get() {
        return this.$store.state.common.menuList;
      },
      set(val) {
        this.$store.commit("common/updateMenuList", val);
      },
    },
    menuActiveName: {
      get() {
        return this.$store.state.common.menuActiveName;
      },
      set(val) {
        this.$store.commit("common/updateMenuActiveName", val);
      },
    },
    mainTabs: {
      get() {
        return this.$store.state.common.mainTabs;
      },
      set(val) {
        this.$store.commit("common/updateMainTabs", val);
      },
    },
    mainTabsActiveName: {
      get() {
        return this.$store.state.common.mainTabsActiveName;
      },
      set(val) {
        this.$store.commit("common/updateMainTabsActiveName", val);
      },
    },
       userName: {
        get () {
          return this.$store.state.user.name
        }
      },
  },
    methods: {
        selectMenu(key, keyPath) {
            // console.log(key, keyPath)
            this.currentIndexLight = key;
        },
        // 展开指定的 sub-menu
        handleOpen(key, keyPath) {
            console.log('展开的时候触发', key, keyPath);

        },

        //    收起指定的 sub-menu
        handleClose(key, keyPath) {
            console.log('收起的时候触发', key, keyPath);
        },

  // 路由操作
    routeHandle(route) {
      if (route.meta.isTab) {
        // tab选中, 不存在先添加
        var tab = this.mainTabs.filter((item) => item.name === route.name)[0];
        console.log()
        if (!tab) {
          if (route.meta.isDynamic) {
            route = this.dynamicMenuRoutes.filter(
              (item) => item.name === route.name
            )[0];
            if (!route) {
              return console.error("未能找到可用标签页!");
            }
          }
          tab = {
            menuId: route.meta.menuId || route.name,
            name: route.name,
            title: route.meta.title,
            // type: isURL(route.meta.iframeUrl) ? 'iframe' : 'module',
            iframeUrl: route.meta.iframeUrl || "",
            params: route.params,
            query: route.query,
          };
          this.mainTabs = this.mainTabs.concat(tab);
        }
        this.menuActiveName = tab.path;
        this.mainTabsActiveName = tab.name;      
    }
    }
    }
}
</script>
